import { connect } from 'react-redux';
import { compose } from 'utils/react';
import {
  toggleComponentLibrary,
  sectionStartDragging,
  sectionStopDragging,
  widgetStartDragging,
  widgetStopDragging,
} from 'store/modules/builder';
import { revise, saveVersion, getPageType } from 'store/modules/pageBuilder';
import { getFlipper, getLeadSources } from 'store/modules/company';
import {
  FLIPPER_ENTERPRISE_OPTIONS,
  FLIPPER_RENTAL_CENTER_OPTIONS,
} from '../../../../../constants/flippers';
import { enabledFlippers } from '../../../../web/components/sections/manifest';
import AdminPageBuilder from '../components/AdminPageBuilder';

const mapStateToProps = state => ({
  showComponentLibrary: state.builder.showComponentLibrary,
  isSectionDragging: state.builder.sectionIsDragging,
  pageType: getPageType(state),
  presentPage: state.pageBuilder,
  sources: getLeadSources(state),
  accessEnterpriseOptions: getFlipper(state, FLIPPER_ENTERPRISE_OPTIONS),
  accessRentalCenterOptions: getFlipper(state, FLIPPER_RENTAL_CENTER_OPTIONS),
  ...enabledFlippers.reduce((acc, flipper) => (
    { ...acc, [flipper]: getFlipper(state, flipper) }
  ), {}),
});

const mapDispatchToProps = {
  revise,
  saveVersion,
  onToggleComponentLibrary: toggleComponentLibrary,
  onSectionStartDragging: sectionStartDragging,
  onSectionStopDragging: sectionStopDragging,
  onWidgetStartDragging: widgetStartDragging,
  onWidgetStopDragging: widgetStopDragging,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AdminPageBuilder);
